<template>
  <div>
    <Head title="International Suppliers" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/suppliers/${supplier.id}/supplierSkus`">
        {{ supplier.name }}
      </Link>
      <span class="text-orange-400 font-medium">/</span> Create SKU
    </h1>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden mb-3">
      <form @submit.prevent="store">        
        <div class="flex flex-wrap -mb-16 -mr-6 p-8 mb-3">
          <div class="pb-8 pr-6 w w-full lg:w-full">
            <multiselect
              v-model="selectedSku"
              id="sku_id"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.sku_id"
              :style= "form.errors.sku_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchSkusChange"
              @input="onSelectedSku"
            />
            <div v-if="form.errors.sku_id" class="form-error">{{ form.errors.sku_id }}</div>
          </div>
          <text-input v-model="form.quantity" type="text" :error="form.errors.quantity" class="pb-8 pr-6 w-full lg:w-1/2" label="Quantity/Container" />
          <text-input v-model="form.order_placed" type="text" :error="form.errors.order_placed" class="pb-8 pr-6 w-full lg:w-1/2" label="Order Placed to; End of Production" />
          <text-input v-model="form.end_of_production" type="text" :error="form.errors.end_of_production" class="pb-8 pr-6 w-full lg:w-1/2" label="End of Production to; End of INSP/SMPL" />
          <text-input v-model="form.end_of_INSP" type="text" :error="form.errors.end_of_INSP" class="pb-8 pr-6 w-full lg:w-1/2" label="End of INSP/SMPL to; End of Shipment Prep + Buffer" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100 mt-4">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Add Supplier SKU</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    countries: Array,
    filters: Object,
    supplier: Object,
    skus: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        quantity: null,
        order_placed: null,
        end_of_production: null,
        end_of_INSP: null,
        sku_id: '',
      }),
      selectedSku: null,
    }
  },
  methods: {
    store() {
      this.form.post(`/suppliers/${this.supplier.id}/supplierSkus`)
    },
    onSearchSkusChange: throttle(function (search) {
        this.$inertia.get(`/suppliers/${this.supplier.id}/supplierSkus/create`, {search}, {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 200),
    onSelectedSku(sku, id) {
      this.form.sku_id = sku;
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
